import React from 'react';
import { connect } from 'react-redux';
import styles from './styles.less';
import { Link } from 'react-router-dom';
import { get } from 'lodash';

import Image from '../image';
import DrawingCanvas from '../drawing-canvas';
import { comicsSelector } from '../../selectors/comicsSelector';

class Comic extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            imageLoaded: false,
        };
    }

    render() {
        var data = this.props.data;
        var allSeries = this.props.series;
        var series = (data.series) ? allSeries[data.series] : data;
        var currentComic = (this.props.comic) ? this.props.comic : series.comics[data.index - 1];
        if (currentComic === undefined) {
            currentComic = series.comics[0];
        }

        const title = `${series.title} by ${series.artist}`;

        const imageLoaded = this.state.imageLoaded;
        const isDrawable = this.getIsDrawable();
        const maxWidth = this.getMaxWidth();
        const isSubmittable = data.submitImage;
        const image = (
            <Image
                data={ currentComic }
                maxWidth={ (isDrawable && imageLoaded) ? '' : maxWidth } // don't set max width on image if this is a canvas
                onLoad={ this.handleImageLoaded.bind(this) }
                title={ title }
            />
        );
        const canvas = (
            <DrawingCanvas
                className={ styles.drawingWrapper }
                clear
                image={ image }
                isSubmittable={ isSubmittable }
                maxWidth={ maxWidth }
            />
        );

        let comicContent = (isDrawable && imageLoaded) ? canvas : image;

        return (
            <div className={ this.props.className }>
                { data.headerImage &&
                <img
                    className={ styles.headerImage }
                    src={ data.headerImage }
                />
                }

                { comicContent }

                { (series && series.comics && series.comics.length > 0 && this.props.seriesLink) &&
                <div className={ styles.viewAll }>
                    <h3>{ this.props.series[data.series].title }</h3>
                    <p>
                        <a
                            className={ styles.artistSite }
                            href={ this.props.series[data.series].artistSite }
                            target="_blank">by { this.props.series[data.series].artist }
                        </a>
                    </p>
                    <p className={ styles.viewAll }>
                        <Link
                            className={ styles.viewAllLink }
                            to={ '/comics/' + data.series }
                        >
                            View Series
                        </Link>
                    </p>
                </div>
                }
            </div>
        );
    }

    handleImageLoaded () {
        this.setState({ imageLoaded: true });
    }

    getIsDrawable () {
        const data = this.props.data;
        const allSeries = this.props.series;
        const series = (data.series) ? allSeries[data.series] : data;

        return get(series, 'isDrawable', false);
    }

    getMaxWidth () {
        const data = this.props.data;

        return get(data, 'maxWidth', null);
    }
}

function mapStateToProps (state) {
    return {
        series: comicsSelector(state)
    };
}


export default connect(mapStateToProps)(Comic);



// WEBPACK FOOTER //
// ./src/client/components/comics/comic.js